
import { useRef, useEffect, useState } from "react";

export default function Testimonials() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);
  
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      {
        threshold: 0.1,
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const testimonials = [
    {
      quote: "Music Nation transformed how I manage my catalog. The royalty tracking is transparent and the legal protection is invaluable.",
      name: "Yasmin Al Meer",
      title: "Recording Artist"
    },
    {
      quote: "Getting properly licensed was simple and straightforward. Now we can play music in our venues with complete peace of mind.",
      name: "Ahmed Nasser",
      title: "Cafe Chain Owner"
    },
    {
      quote: "As a producer, protecting my work was always challenging until I joined Music Nation. Their platform makes rights management effortless.",
      name: "David Rahman",
      title: "Music Producer"
    }
  ];

  return (
    <section ref={sectionRef} className="bg-musicCharcoal py-24 section-transition relative overflow-hidden">
      {/* Animated light blobs */}
      <div className="light-blob light-blob--1"></div>
      <div className="light-blob light-blob--2"></div>

      {/* Noise texture overlay */}
      <div className="noise-overlay"></div>

      <div className="editorial-container relative z-10">
        <h2 className={`editorial-heading text-center mb-16 transition-all duration-1000 transform text-white ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          Voices of the Community
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index} 
              className={`bg-musicBlack border border-musicGrey/20 p-8 rounded-lg transition-all duration-1000 transform hover-lift spotlight shadow-lg`}
              style={{ 
                opacity: isVisible ? 1 : 0,
                transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
                transitionDelay: `${index * 200}ms`,
                boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)'
              }}
            >
              <div className="mb-6 text-musicRed">
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="drop-shadow-md filter">
                  <path d="M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1z" />
                  <path d="M15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2h.75c0 2.25.25 4-2.75 4v3c0 1 0 1 1 1z" />
                </svg>
              </div>
              <p className="text-lg italic text-white mb-6 leading-relaxed">"{testimonial.quote}"</p>
              <div className="mt-auto">
                <p className="font-bold text-white">{testimonial.name}</p>
                <p className="text-sm text-musicRed mt-1">{testimonial.title}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      
      {/* Angular divider for transition */}
      <div className="absolute bottom-0 left-0 right-0 overflow-hidden z-10">
        <svg 
          className="w-full" 
          style={{ height: "60px", display: "block" }}
          viewBox="0 0 1200 60" 
          preserveAspectRatio="none" 
          xmlns="http://www.w3.org/2000/svg"
          fill="#ff3b3b"
        >
          <polygon points="0,60 1200,60 1200,0 600,60 0,0" />
        </svg>
      </div>
    </section>
  );
}
